import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const TaskExecutorSchema = createComponentSchema(
  'TaskExecutor',
  z.object({
    taskUuid: z.string().optional(),
    returnUrl: z.string().optional(),
    returnOnFinish: z.boolean().optional()
  })
)

export default TaskExecutorSchema
